<template>
    <div v-show="exceptionVisible" class="load-failed">
        <div>
            <span>{{info}}</span>
            <el-button type="primary" link @click="loadResult">重新加载</el-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        info: {
            type: String,
            default: '数据获取失败'
        }
    },
    mounted() {
        if (this.visible) {
            this.show(true);
        }
    },
    data() {
        const { visible } = this;
        return {
            exceptionVisible: !!visible
        };
    },
    watch: {
        visible(newValue) {
            this.show(newValue);
        }
    },
    methods: {
        show(flag) {
            this.exceptionVisible = flag;
        },
        loadResult() {
            this.$emit('reload');
        }
    }
};
</script>

<style lang="scss" scoped>
    .load-failed {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: absolute;
        background: #ffffff;
        border-radius: $border-base-radius;
        z-index: 1985;
        text-align: center;
        div {
            position: relative;
            top: 42%;
            span {
                height: 14px;
                line-height: 14px;
                font-size: 14px;
                color: #A1A7B7;
                vertical-align: middle;
            }
            .el-button--text, .el-button--text:hover, .el-button--text:focus {
                margin-left: 15px;
                font-size: 14px;
                line-height: 14px;
            }
        }
    }

</style>
